<template>
  <div>
    <div class="panel-body">
      <div
        v-for="comment in comments"
        :key="comment.id"
      >
        <div class="media">
          <div class="media-left">
            <q-avatar
              :size="50"
              :src="comment.userAvatar"
            />
          </div>
          <div
            class="media-body"
            style="padding-left: 15px"
          >
            <h4 class="media-heading">
              <span>{{ comment.user }}</span>
              <small>{{ comment.time }}</small>
            </h4>
            <p>{{ comment.text }}</p>
            <comments :comments="comment.replies" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

  export default {
    name: "Comments",

    props: {
      comments: {
        required: true
      }
    },

    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>